var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Level2 = function Level2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      opacity: ".4",
      d: "M18.5 3A1.5 1.5 0 0 0 17 4.5v15a1.5 1.5 0 0 0 3 0v-15A1.5 1.5 0 0 0 18.5 3Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M10 8.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11ZM3 12.5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0v-7Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Level2;